// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedUserCard-cls1_W4I","cls2":"SuggestedUserCard-cls2_2RT SuggestedUserCard-cls1_W4I"};